/* eslint-disable no-useless-escape */
type objTypes = {
  label: string;
  product?: string;
  IDofEmail?: string;
};
export const productReturnPath: Record<string, string> = {
  'gst': '?product=gst&return_path=L24vc3NvP3JlZGlyZWN0X3VybD1MMjQ9',
  'e-invoicing-gst': '?product=einvoice&return_path=L3Nzbz9yZHI9Lw==',
  'business': '?product=business&return_path=L2xhdW5jaHBhZD9zb3VyY2U9Z3N0',
  'individuals':
    '?product=cleartax&return_path=L015QWNjb3VudC9zdGFydD9yZWY9c3Nv',
  'ca': '?product=tax_experts&return_path=L2xhdW5jaHBhZD9zb3VyY2U9Z3N0',
  'sme': '?product=sme&return_path=L2xhdW5jaHBhZD9zb3VyY2U9Z3N0',
  'enterprise': '?product=einvoice&return_path=L3Nzbz9yZHI9Lw==',
  'tds': '?product=tds&return_path=L2FwaS9hY2NvdW50L2xvZ2luX2NhbGxiYWNr',
  'taxcloud': '?product=taxcloud&return_path=L0VudGl0eQ==',
  'eway-bill': '?product=eway_bill&return_path=Lw==',
  'default': '?product=cleartax&return_path=L015QWNjb3VudC9zdGFydA==',

  'einvoice': '?product=einvoice',
  'tdsNoReturnPath': '?product=tds',
  'ewaybillNoReturnPath': '?product=eway_bill',
  'gstNoReturnPath': '?product=gst',
  'maxitc': '?product=mtsg&return_path=Lw==',
};

export const googleLoginSignUp = (
  obj: HTMLElement,
  logObj: objTypes
): boolean | undefined => {
  const { label = '', product = '', IDofEmail = '' } = logObj;
  obj.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
  const email = document.getElementById(
    IDofEmail || obj.previousElementSibling?.id || ''
  ) as HTMLInputElement;
  const emailVal = (email && email.value) || '';
  const emailRegex =
    /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  if ((!emailVal || emailVal == '' || !emailRegex.test(emailVal)) && document) {
    const errorEl = document.getElementById('errmsg');
    if (errorEl) errorEl.innerHTML = 'Please enter a valid Email ID';
    email && email.focus();
    return;
  }
  let signUpUrl = 'https://accounts.cleartax.in/v2';
  signUpUrl += productReturnPath[product] || productReturnPath.default;
  signUpUrl +=
    '&source=' +
    window.location.pathname.slice(3) +
    '&ref={{page.parent_category}}_' +
    label +
    '&s_username=' +
    emailVal;

  window.location.href = signUpUrl;
  return false;
};
